export const userColumns = [
    {
        title: 'Nombre',
        dataIndex: 'name',
        key: 'name',
        width: 150,
        align: 'center',
    },
    {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
        width: 150,
        align: 'center',
    },
    {
        title: 'Ingreso a BD',
        dataIndex: 'bd',
        key: 'bd',
        width: 150,
        align: 'center',
    },
    {
        title: 'ToS',
        dataIndex: 'tos',
        key: 'tos',
        width: 150,
        align: 'center',
    },
    {
        title: 'Borrar cuenta',
        dataIndex: 'deletion',
        key: 'deletion',
        width: 100,
        align: 'center',
    },
    // {
    //     title: 'Pais',
    //     dataIndex: 'country',
    //     key: 'country',
    //     width: 100,
    //     align: 'center',
    // }
];


